// @see https://docs.getelevar.com/docs/headless-overview
export enum ELEVAR_DATA_LAYER_EVENTS {
  DL_ADD_TO_CART = 'dl_add_to_cart',
  DL_REMOVE_FROM_CART = 'dl_remove_from_cart',
  DL_SELECT_ITEM = 'dl_select_item',
  DL_SUBSCRIBE = 'dl_subscribe',
  DL_USER_DATA = 'dl_user_data',
  DL_VIEW_CART = 'dl_view_cart',
  DL_VIEW_ITEM = 'dl_view_item',
  DL_VIEW_ITEM_LIST = 'dl_view_item_list',
  DL_VIEW_SEARCH_RESULTS = 'dl_view_search_results',
}
